import * as $ from "jquery";

export function BindOnClickOutside($elem: JQuery, id: string, handler: (handlerEvent) => void): JQuery {
    const event = $("html").on("click." + id, (e) => {
        const $clickedElem = $(e.target);

        if (!$elem.find($clickedElem).length && !$clickedElem.is($elem)) {
            handler(e);
        }
    });

    return event;
}

export function UnbindOnClickOutside(id: string): void {
    $("html").unbind("." + id);
}
